var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adBox"},_vm._l((_vm.$root.adList.indexBannerAd),function(item){return (_vm.$root.adList && _vm.$root.adList.indexBannerAd)?_c('div',{key:item.id},[_c('a',{attrs:{"href":item.url}},[_c('img',{staticClass:"bannerImgAd",attrs:{"src":item.imgUrl}})])]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }